import Vue from "vue";
import Vuex from "vuex";

import view from "./modules/view";
import auth from "./modules/auth";
import orders from "./modules/orders";
import repetitiveData from "./modules/repetitiveData";
import authBackoffice from "./modules/authBackoffice";
import claims from "./modules/claims";
import foodcourtClaims from "./modules/foodcourtClaims";
import feedback from "./modules/feedback";
import metrics from "./modules/metrics";
import niveles from "./modules/niveles";
import foodcourtLevels from "./modules/foodcourtLevels";
import foodcourtSchedule from "./modules/foodcourtSchedule";
import tardanza from "./modules/tardanza";
import esperaRepartidor from "./modules/esperaRepartidor";
import tickets from "./modules/tickets";
import auditorias from "./modules/auditorias";
import portalUpdates from "./modules/portalUpdates";
import operationsManual from "./modules/operationsManual";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    view,
    auth,
    orders,
    repetitiveData,
    authBackoffice,
    claims,
    foodcourtClaims,
    feedback,
    tardanza,
    esperaRepartidor,
    metrics,
    niveles,
    foodcourtLevels,
    foodcourtSchedule,
    tickets,
    auditorias,
    portalUpdates,
    operationsManual
  }
});
